import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * FlashcardOutlined icon
 *
 * @file FlashcardOutlined.jsx
 */
const FlashcardOutlined = props => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M20.7499131,3.89281658 L21.5971235,8.69758534 C22.4488721,9.33599586 23,10.3536365
      23,11.5 L23,19.5 C23,21.4329966 21.4329966,23 19.5,23 L6.5,23 C4.56700338,23
      3,21.4329966 3,19.5 L3,16.612641 C2.7268278,16.2136893 2.53237177,15.7514151
      2.44294349,15.2442422 L1.05375806,7.36578013 C0.718096723,5.46215007 1.98918652,3.64684572
      3.89281658,3.31118437 L16.6953174,1.05375806 C18.5989474,0.718096723 20.4142518,1.98918652
      20.7499131,3.89281658 Z M19.5,10 L6.5,10 C5.67157288,10 5,10.6715729 5,11.5 L5,19.5
      C5,20.3284271 5.67157288,21 6.5,21 L19.5,21 C20.3284271,21 21,20.3284271 21,19.5
      L21,11.5 C21,10.6715729 20.3284271,10 19.5,10 Z M15,16 C15.5522847,16 16,16.4477153
      16,17 C16,17.5522847 15.5522847,18 15,18 L9,18 C8.44771525,18 8,17.5522847 8,17
      C8,16.4477153 8.44771525,16 9,16 L15,16 Z M17,13 C17.5522847,13 18,13.4477153
      18,14 C18,14.5522847 17.5522847,15 17,15 L9,15 C8.44771525,15 8,14.5522847 8,14
      C8,13.4477153 8.44771525,13 9,13 L17,13 Z M17.0426137,3.02337357 L4.24011293,5.28079988
      C3.42427148,5.42465474 2.87951871,6.20264232 3.02337357,7.01848378 L3.49654237,9.70195741
      C4.1082484,8.682356 5.22443781,8 6.5,8 L19.4432672,8 L18.7802976,4.24011293
      C18.6364428,3.42427148 17.8584552,2.87951871 17.0426137,3.02337357 Z"
    />
  </SvgIcon>
);

export default FlashcardOutlined;
